import { Modal, UI } from 'common';
import React from 'react';

const { Modal: ModalComponent } = Modal;
const { Link, Typography, MobileAppQRCode, Frame } = UI;

type MobileAppDownloadModalProps = {
	modalId: number;
};

const MobileAppDownloadModal: React.FC<MobileAppDownloadModalProps> = ({
	modalId,
}) => {
	const appStoreUrl =
		'https://apps.apple.com/us/app/stamps-com-mobile-app/id1591959884'; // TODO: Update with actual App Store URL
	const googlePlayUrl =
		'https://play.google.com/store/apps/details?id=stamps.mobile.app&hl=en_US'; // TODO: Update with actual Google Play URL

	return (
		<ModalComponent
			modalId={modalId}
			header="Download the Mobile App"
			className="mobile-app-download-modal"
			hideFooter={true}
			size="small"
			dataqa="mobile-app-download-modal"
		>
			<div className="mobile-app-download-modal-content">
				<div className="mobile-app-download-qr-container">
					<Frame className="mobile-app-download-qr-code">
						<MobileAppQRCode />
					</Frame>
				</div>

				<div className="mobile-app-download-text">
					<Typography.H4>Use Stamps.com while you're on the go.</Typography.H4>
					<Typography.P>
						Scan this QR code with your phone to download the Stamps.com mobile
						app or find it on the{' '}
						<Link
							href={appStoreUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="mobile-app-download-link"
							dataqa="app-store-link"
						>
							App Store
						</Link>
						{' and '}
						<Link
							href={googlePlayUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="mobile-app-download-link"
							dataqa="google-play-link"
						>
							Google Play
						</Link>
						.
					</Typography.P>
				</div>
			</div>
		</ModalComponent>
	);
};

export default MobileAppDownloadModal;
